import {
  Dialog,
  Stack,
  Typography,
  Box,
  Button as NewButton,
} from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import closeIcon from "../../../assets/icon-xout-black.svg";
import closeIconNew from "../../../assets/icon-close.svg";

interface bsProps {
  onClose: any;
  open: boolean;
  children: any;
  showCloseIcon?: boolean;
  restprops?: any;
  curvedBorder?: string;
  containerBox?: string;
  modalTitle?: string;
  modalTitleContent?: string;
  modalDescription?: string;
  modalDescriptionContent?: string;
  curveModal?: boolean;
  customRadiusModal?: string;
  modalclassName?: any;
  scroll?:any;
  onClick?:any;
  showNewCloseIcon?:any;
}

function BSDialog({
  onClose,
  open,
  curvedBorder,
  showCloseIcon = false,
  showNewCloseIcon = false,
  curveModal = false,
  containerBox,
  modalTitle,
  modalTitleContent,
  modalDescription,
  modalDescriptionContent,
  customRadiusModal,
  modalclassName,
  scroll,
  children,
  ...restprops
}: bsProps) {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      aria-labelledby="scroll-dialog-title"
      // aria-describedby="scroll-dialog-description"
      scroll={scroll}
      {...restprops}
      className={curveModal === true ? "customRadiusModal" : ""}
      // style={{ marginTop: "136px" }}
    >
      <Stack className={curvedBorder}>
        {showCloseIcon && (
          <Stack
            direction="row"
            justifyContent="end"
            className="close-icon-cantainer noPrint"
          >
            <Typography component="button" className="buttonText" onClick={onClose}>
            <img
              src={(showNewCloseIcon)?closeIconNew:closeIcon}
              alt="Close the dialog"
              className="cursor-pointer modalCloseIcon"
            />
            </Typography>
          </Stack>
        )}
        {children}
      </Stack>
    </Dialog>
  );
}

export default BSDialog;
